import { Box, styled } from "@mui/material";

export const WrapperList = styled(Box)(({ theme }) => ({
  flex: 1,

}));

export const InfinitiveScrollWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  width: '100%',
}));